import type { SavedReport } from '../interfaces';
import type { ApiResponse } from '@Types';
import { API } from '@Providers';

export default async function (dataTableId: string) {
  const endpoint = `/api/shelter/saved-reports?data_table_id=${encodeURIComponent(dataTableId)}`;

  return API({ endpoint, method: 'get' }) as Promise<ApiResponse<SavedReport[]>>;
}
